export const asideBook = {
    back: {
        title: "Retourner au tableau des finances",
        label: "Retour au tableau"
    }
}
